import { useContext, useEffect, useState } from "react";
import { AppContext } from "contexts/AppContext";
import { Box } from "@mui/material";
import { callAPI } from "utils/API";
import FrontPageCustomSection from "./FrontPageCustomSection";
import FrontPageBanner from "./FrontPageBanner";
import CategorySection from "./CategorySection";
import BrandsSection from "./BrandsSection";
import FrontPageFaqSection from "./FrontPageFaqSection";
import PopularProductsSection from "./PopularProductsSection";
import NewProductsSection from "./NewProductsSections";

const Home2 = () => {
    const { brandData } = useContext(AppContext)
    const [frontPageSections, setFrontPageSections] = useState([])
    const [isFrontPageSectionsLoading, setIsFrontPageSectionsLoading] = useState(true)

    const fetchSections = async () => {
        const sections = await callAPI("/pageSections", "GET");
        if (sections && sections.length > 0) {
            setFrontPageSections(sections)
        }
        setIsFrontPageSectionsLoading(false)
    }

    useEffect(() => {
        fetchSections()
    }, [])

    return (
        <Box display={'flex'} flexDirection={'column'} gap={{xs: 10, md: 16}}>
            <FrontPageBanner />

            {!!brandData?.features?.enableHomeNewProductsSection &&
              <NewProductsSection />
            }

            <FrontPageCustomSection section={frontPageSections[0]} isLoading={isFrontPageSectionsLoading} />

            {!brandData?.features?.disableHomeCategorySection &&
              <CategorySection />
            }

            <FrontPageCustomSection section={frontPageSections[1]} isLoading={isFrontPageSectionsLoading} />

            {!brandData?.features?.disableHomeBrandSection &&
              <BrandsSection />
            }

            {!brandData?.features?.disableHomeFaqSection &&
              <FrontPageFaqSection />
            }

            {!brandData?.features?.disableHomePopularProductsSection &&
              <PopularProductsSection />
            }
        </Box>
    )
}

export default Home2;